import { isDraftListingLink } from '../../../../AssetTargetsDialog/helpers/assetProductLinks';
import {
  isProductLinkActionable,
  isVariantLinkActionable,
} from './productLinkActionable';

export const isProductLinkDetachable = (link, { isMaster = false } = {}) => {
  if (!isProductLinkActionable(link, { isMaster })) return false;
  if (isMaster || link?.type === 'master') return true;
  return isDraftListingLink(link);
};

export const isVariantLinkDetachable = (link) => {
  if (!isVariantLinkActionable(link)) return false;
  if (link?.type === 'masterVariant') return true;
  return isDraftListingLink(link);
};
